import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LoadingController, Platform, ToastController } from '@ionic/angular';
import jsQR from 'jsqr';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-qrread',
  templateUrl: './qrread.component.html',
  styleUrls: ['./qrread.component.scss'],
})
export class QRReadComponent implements OnInit {

  @ViewChild('video', { static: false }) video: ElementRef;
  @ViewChild('canvas', { static: false }) canvas: ElementRef;
  @ViewChild('fileinput', { static: false }) fileinput: ElementRef;

  @Output() Parado = new EventEmitter();
  @Output() getCodigo = new EventEmitter();
  @Output() Error = new EventEmitter();

  @Input() set Escanear(val){
    if(val>0){
      this.startScan()
    }
  }

  @Input() set Subir(val){
    if(val>0){
      this.captureImage()
    }
  }

  @Input() Botones:boolean=true;

  constructor(
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private plt: Platform,
    private utilidades: UtilidadesService
  ) {
    const isInStandaloneMode = () =>
      'standalone' in window.navigator && window.navigator['standalone'];
    if (this.plt.is('ios') && isInStandaloneMode()) {
      // E.g. hide the scan functionality!
    }
  }

  canvasElement: any;
  videoElement: any;
  canvasContext: any;
  scanActive = false;
  scanResult = null;
  loading: HTMLIonLoadingElement = null;
  stream:any;
  ngOnInit() {
  }

  ngAfterViewInit() {
    this.canvasElement = this.canvas.nativeElement;
    this.canvasContext = this.canvasElement.getContext('2d');
    this.videoElement = this.video.nativeElement;
  }


   
    reset() {
      this.scanResult = null;
    }
   
    stopScan() {
      this.scanActive = false;
      this.stream.getTracks().forEach(function(track) {
        track.stop();
      });

      this.Parado.emit(true)
    }

    async showQrToast() {
      const toast = await this.toastCtrl.create({
        message: `Open ${this.scanResult}?`,
        position: 'top',
        buttons: [
          {
            text: 'Open',
            handler: () => {
              window.open(this.scanResult, '_system', 'location=yes');
            }
          }
        ]
      });
      toast.present();
    }


    async startScan() {
      // Not working on iOS standalone mode!
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' }
      }).catch(err => {
        this.utilidades.Depuracion(err, "console", "")
        this.Error.emit(err); return 0});

      this.stream=stream
     
      this.videoElement.srcObject = stream;
      // Required for Safari
      this.videoElement.setAttribute('playsinline', true);
     
      this.loading = await this.loadingCtrl.create({});
      await this.loading.present();
     
      this.videoElement.play();
      requestAnimationFrame(this.scan.bind(this));
    }
     
    async scan() {
      if (this.videoElement.readyState === this.videoElement.HAVE_ENOUGH_DATA) {
        if (this.loading) {
          await this.loading.dismiss();
          this.loading = null;
          this.scanActive = true;
        }
     
        this.canvasElement.height = this.videoElement.videoHeight;
        this.canvasElement.width = this.videoElement.videoWidth;
     
        this.canvasContext.drawImage(
          this.videoElement,
          0,
          0,
          this.canvasElement.width,
          this.canvasElement.height
        );
        const imageData = this.canvasContext.getImageData(
          0,
          0,
          this.canvasElement.width,
          this.canvasElement.height
        );
        const code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'dontInvert'
        });
     
        if (code) {
          this.scanActive = false;
          this.scanResult = code.data;
          // this.showQrToast();
          this.getCodigo.emit(this.scanResult)

        } else {
          if (this.scanActive) {
            requestAnimationFrame(this.scan.bind(this));
          }
        }
      } else {
        requestAnimationFrame(this.scan.bind(this));
      }
    }

    captureImage() {
  this.fileinput.nativeElement.click();
}
 
handleFile(files: FileList) {
  const file = files.item(0);
 
  var img = new Image();
  img.onload = () => {
    this.canvasContext.drawImage(img, 0, 0, this.canvasElement.width, this.canvasElement.height);
    const imageData = this.canvasContext.getImageData(
      0,
      0,
      this.canvasElement.width,
      this.canvasElement.height
    );
    const code = jsQR(imageData.data, imageData.width, imageData.height, {
      inversionAttempts: 'dontInvert'
    });
 
    if (code) {
      this.scanResult = code.data;
      // this.showQrToast();
      this.getCodigo.emit(this.scanResult)
    }
  };
  img.src = URL.createObjectURL(file);
}

}
